import { zodResolver } from '@hookform/resolvers/zod'
import { Box, Typography } from '@material-ui/core'
import { useEffect } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { z } from 'zod'

import Button from '@/components/button'
import InputText from '@/components/input-text'
import { useAuth } from '@/hooks/use-auth'
import { useTimeLeft } from '@/hooks/use-time-left'
import { updateUser } from '@/services/update-user'

import { Layout } from '../layout'
import { useStyles } from './styles'

interface FormValues {
  name: string
}

const regexForValidateNames = /^([ \u00c0-\u01ffa-zA-Z'])+$/
const formSchema = z.object({
  name: z
    .string()
    .min(1, 'O campo é obrigatório')
    .regex(regexForValidateNames, 'Insira um valor válido'),
})

export default function EditName() {
  const classes = useStyles()
  const { user, signOut } = useAuth()
  const { setTimeLeft, timeLeft } = useTimeLeft(() => signOut())
  const navigate = useNavigate()

  const {
    handleSubmit,
    register,
    setValue,
    setError,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      name: '',
    },
    mode: 'onChange',
    resolver: zodResolver(formSchema),
  })

  const onSubmitUserNameForm: SubmitHandler<FormValues> = async (data) => {
    try {
      await updateUser(user.id, data.name)
      setTimeLeft(10)
    } catch (err: any) {
      setError('name', { message: 'Erro ao atualizar o nome' })
    }
  }

  useEffect(() => {
    if (user) setValue('name', user.name)
  }, [])

  return (
    <Layout>
      <Typography variant={'h3'}>Informações básicas</Typography>
      <form onSubmit={handleSubmit(onSubmitUserNameForm)}>
        <Box className={classes.wrapper}>
          <Typography variant={'h4'}>
            As mudanças feitas no seu nome irão afetar toda a sua conta cromai
          </Typography>
          <InputText
            id='name-input'
            label={'Nome'}
            error={Boolean(errors.name)}
            success={Boolean(timeLeft)}
            helperText={
              errors.name?.message ||
              (timeLeft &&
                `Nome alterado com sucesso! Você será redirecionado para o login em ${timeLeft}s`)
            }
            {...register('name')}
          />
        </Box>
        <Box display='flex' justifyContent='flex-end' gridGap='1.6rem'>
          <Button outlined className={classes.btn} onClick={() => navigate(-1)}>
            Cancelar
          </Button>
          <Button
            className={classes.btn}
            disabled={!!errors.name}
            type={'submit'}
            loading={isSubmitting}
          >
            Salvar
          </Button>
        </Box>
      </form>
    </Layout>
  )
}
